import React, { useState } from 'react'
import { Form, Link, usePage } from '@inertiajs/react'
import AuthLayout from '../../components/AuthLayout'

export default function ResetPassword({ reset_password_token, minimum_password_length }) {
  const { errors } = usePage().props
  const [processing, setProcessing] = useState(false)

  const userErrors = errors?.user || errors || {}

  return (
    <AuthLayout>
      <div className="text-center text-white">
        <h2 className="text-2xl font-bold mb-2">Alterar sua senha</h2>
        {minimum_password_length && (
          <p className="text-sm mb-6 text-gray-200">
            Minimo de {minimum_password_length} caracteres.
          </p>
        )}

        <Form
          action="/users/password"
          method="put"
          data={{ user: { reset_password_token: reset_password_token || '' } }}
          options={{ forceFormData: true }}
          onStart={() => setProcessing(true)}
          onFinish={() => setProcessing(false)}
        >
          <div className="mb-4">
            <input
              type="password"
              name="user[password]"
              placeholder="Nova senha"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoFocus
              autoComplete="new-password"
            />
            {userErrors.password && (
              <div className="mt-1 text-red-300 text-sm text-left">{userErrors.password}</div>
            )}
          </div>

          <div className="mb-6">
            <input
              type="password"
              name="user[password_confirmation]"
              placeholder="Confirmar nova senha"
              className="w-full h-12 px-4 rounded-lg bg-white/65 text-gray-800 placeholder-gray-500 border-0 focus:ring-2 focus:ring-brand-light"
              autoComplete="new-password"
            />
            {userErrors.password_confirmation && (
              <div className="mt-1 text-red-300 text-sm text-left">{userErrors.password_confirmation}</div>
            )}
          </div>

          <button
            type="submit"
            disabled={processing}
            className="w-full h-12 bg-brand-light hover:bg-white hover:text-brand-dark text-white font-medium rounded-lg transition-colors disabled:opacity-50 mb-6"
          >
            {processing ? 'Alterando...' : 'Alterar minha senha'}
          </button>

          <div className="space-y-2 text-sm">
            <Link href="/users/sign_in" className="block hover:underline">
              Voltar para o login
            </Link>
          </div>
        </Form>
      </div>
    </AuthLayout>
  )
}
